var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };} /** @format */

import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Translate } from "../../I18N";
import { Icon } from "../../UI";
import { bindActionCreators } from 'redux';
import { closeImportProgress } from "../actions/uploadsActions";
import Immutable from 'immutable';
import StackTrace from "../../components/Elements/StackTrace";

export class ImportProgress extends Component {
  render() {
    const {
      close,
      importState: { importStart, importProgress, importError, importEnd }
    } = this.props;
    if (!importStart && !importProgress) {
      return false;
    }
    if (importEnd) {
      return /*#__PURE__*/(
        _jsx("div", { className: "alert alert-info" }, void 0, /*#__PURE__*/
        _jsx(Icon, { icon: "check", size: "2x" }), /*#__PURE__*/
        _jsx("div", { className: "force-ltr" }, void 0, /*#__PURE__*/
        _jsx(Translate, {}, void 0, "Import completed:"), "\xA0", importProgress, ' ', /*#__PURE__*/
        _jsx(Translate, {}, void 0, "created"), /*#__PURE__*/
        _jsx("br", {}), /*#__PURE__*/
        _jsx(Translate, {}, void 0, "Indexing entities may take a few minutes")), /*#__PURE__*/

        _jsx(Icon, { style: { cursor: 'pointer' }, icon: "times", onClick: close })));


    }

    if (importError.get('prettyMessage')) {
      return /*#__PURE__*/(
        _jsx("div", {}, void 0, /*#__PURE__*/
        _jsx("div", { className: "alert alert-danger" }, void 0, /*#__PURE__*/
        _jsx(Icon, { icon: "exclamation-triangle", size: "2x" }), /*#__PURE__*/
        _jsx("div", { className: "force-ltr" }, void 0, /*#__PURE__*/
        _jsx(Translate, {}, void 0, "The import process threw an error:")), /*#__PURE__*/

        _jsx(Icon, { style: { cursor: 'pointer' }, icon: "times", onClick: close })), /*#__PURE__*/

        _jsx(StackTrace, {
          message: importError.get('prettyMessage'),
          validations: importError.get('validations') })));



    }

    return /*#__PURE__*/(
      _jsx("div", { className: "alert alert-info" }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: "cog", size: "2x" }), /*#__PURE__*/
      _jsx("div", { className: "force-ltr" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Importing data in progress"), ": ", importProgress)));



  }
}











export const mapStateToProps = (state) => ({
  importState: state.importEntities
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ close: closeImportProgress }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ImportProgress);